import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const NotaryPage = lazy(() => import('../pages/notary/page'));
const PartnershipsPage = lazy(() => import('../pages/partnerships/page'));
const ServiceAreaPage = lazy(() => import('../pages/service-area/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const FeesPage = lazy(() => import('../pages/fees/page'));
const QRCodePage = lazy(() => import('../pages/qr-code/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/notary',
    element: <NotaryPage />,
  },
  {
    path: '/partnerships',
    element: <PartnershipsPage />,
  },
  {
    path: '/service-area',
    element: <ServiceAreaPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/fees',
    element: <FeesPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/qr-code',
    element: <QRCodePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
